const SYNC_KEY = 'oem_last_synced_at'
const DEFAULT_LOOKBACK_MS = 24 * 60 * 60 * 1000  // 24h

export function getLastSyncedAt(): Date {
  try {
    const stored = localStorage.getItem(SYNC_KEY)
    if (stored) return new Date(stored)
  } catch { /* ignore */ }
  return new Date(Date.now() - DEFAULT_LOOKBACK_MS)
}

export function advanceLastSyncedAt(): void {
  try {
    localStorage.setItem(SYNC_KEY, new Date().toISOString())
  } catch { /* storage full — non-critical */ }
}
